import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { url: String };

  copy(e) {
    e.preventDefault()
    
    navigator.clipboard.writeText(this.urlValue).then(() => {
      this.showFlash('Share link copied to clipboard!')
    }).catch(() => {
      this.showFlash('Failed to copy link!', 'danger')
    });
  }

  showFlash(message, bg = 'primary') {
    const flashContainer = document.querySelector('#flash')
    
    // Create a new flash message
    const flashMessage = document.createElement('div')
    flashMessage.className = 'flash__message'
    flashMessage.classList.add(`color-bg--${bg}`)
    flashMessage.setAttribute('data-controller', 'removals')
    flashMessage.setAttribute('data-action', 'animationend->removals#remove')
    flashMessage.textContent = message

    // Append the flash message to the container
    flashContainer.appendChild(flashMessage)
  }
}